export const accessRightsReport = {
    defaultType: 'admin',
    types: {
        admin: {
            name: 'admin',
            isDisabled: false,
            isAllowed: true,
            order: 25,
            blocks: [
                {
                    name: 'bisnodeCertificates',
                    isDisabled: false,
                    order: 1,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'indicators',
                    isDisabled: false,
                    order: 2,
                    defaultLevel: 50,
                    availableLevels: [10, 30, 50],
                    flags: null,
                    parameters: { debt: true, trade: true },
                },
                {
                    name: 'syntheticIndicators',
                    isDisabled: false,
                    order: 3,
                    defaultLevel: 50,
                    availableLevels: [10, 30, 50],
                    flags: null,
                },
                {
                    name: 'basicInformation',
                    isDisabled: false,
                    order: 4,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'regInfo',
                    isDisabled: false,
                    order: 5,
                    defaultLevel: 20,
                    availableLevels: [10, 20],
                    flags: null,
                },
                {
                    name: 'contacts',
                    isDisabled: false,
                    order: 6,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'addresses',
                    isDisabled: false,
                    order: 7,
                    defaultLevel: 40,
                    availableLevels: [20, 40],
                    flags: null,
                },
                { name: 'velikost', isDisabled: false, order: 8, defaultLevel: 20, availableLevels: [20], flags: null },
                {
                    name: 'activities',
                    isDisabled: false,
                    order: 9,
                    defaultLevel: 20,
                    availableLevels: [20],
                    flags: null,
                },
                {
                    name: 'persons',
                    isDisabled: false,
                    order: 10,
                    defaultLevel: 40,
                    availableLevels: [10, 20, 30, 40],
                    flags: null,
                },
                {
                    name: 'bisnodeScoring',
                    isDisabled: false,
                    order: 11,
                    defaultLevel: 40,
                    availableLevels: [10, 20, 30, 40],
                    flags: null,
                },
                {
                    name: 'paymentIndex',
                    isDisabled: false,
                    order: 12,
                    defaultLevel: 40,
                    availableLevels: [10, 20, 30, 40],
                    flags: null,
                },
                {
                    name: 'ownership',
                    isDisabled: false,
                    order: 15,
                    defaultLevel: 20,
                    availableLevels: [10, 20],
                    flags: null,
                },
                {
                    name: 'rolesInCompanies',
                    isDisabled: false,
                    order: 17,
                    defaultLevel: 20,
                    availableLevels: [10, 20],
                    flags: { new: true },
                },
                {
                    name: 'negativeEvents',
                    isDisabled: false,
                    order: 18,
                    defaultLevel: 20,
                    availableLevels: [10, 20],
                    flags: null,
                },
                {
                    name: 'liens',
                    isDisabled: false,
                    order: 19,
                    defaultLevel: 20,
                    availableLevels: [10, 20],
                    flags: { new: true },
                },
                {
                    name: 'inspections',
                    isDisabled: false,
                    order: 20,
                    defaultLevel: 30,
                    availableLevels: [10, 30],
                    flags: null,
                },
                {
                    name: 'companyAsCreditor',
                    isDisabled: false,
                    order: 21,
                    defaultLevel: 20,
                    availableLevels: [10, 20],
                    flags: null,
                },
                {
                    name: 'contracts',
                    isDisabled: false,
                    order: 22,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: { new: true },
                },
                {
                    name: 'publicTenders',
                    isDisabled: false,
                    order: 23,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'businessPartners',
                    isDisabled: false,
                    order: 24,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                { name: 'dotace', isDisabled: false, order: 25, defaultLevel: 10, availableLevels: [10], flags: null },
                {
                    name: 'certificates',
                    order: 26,
                    isDisabled: false,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                { name: 'anotace', isDisabled: false, order: 27, defaultLevel: 10, availableLevels: [10], flags: null },
                {
                    name: 'paymentComparison',
                    isDisabled: false,
                    order: 28,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
            ],
            parameters: { duns: true },
        },
        proverovaci: {
            name: 'proverovaci',
            isDisabled: false,
            isAllowed: true,
            order: 65,
            blocks: [
                {
                    name: 'bisnodeCertificates',
                    isDisabled: false,
                    order: 1,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'indicators',
                    isDisabled: false,
                    order: 2,
                    defaultLevel: 30,
                    availableLevels: [10, 30],
                    flags: null,
                    parameters: { debt: true, trade: true },
                },
                {
                    name: 'syntheticIndicators',
                    isDisabled: false,
                    order: 3,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'basicInformation',
                    isDisabled: false,
                    order: 4,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                { name: 'regInfo', isDisabled: false, order: 5, defaultLevel: 10, availableLevels: [10], flags: null },
                { name: 'contacts', isDisabled: false, order: 6, defaultLevel: 10, availableLevels: [10], flags: null },
                {
                    name: 'addresses',
                    isDisabled: false,
                    order: 7,
                    defaultLevel: 20,
                    availableLevels: [20],
                    flags: null,
                },
                { name: 'velikost', isDisabled: false, order: 8, defaultLevel: 20, availableLevels: [20], flags: null },
                {
                    name: 'activities',
                    isDisabled: false,
                    order: 9,
                    defaultLevel: 20,
                    availableLevels: [20],
                    flags: null,
                },
                { name: 'persons', isDisabled: false, order: 10, defaultLevel: 10, availableLevels: [10], flags: null },
                {
                    name: 'ownership',
                    isDisabled: false,
                    order: 15,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'negativeEvents',
                    isDisabled: false,
                    order: 18,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'liens',
                    isDisabled: false,
                    order: 19,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: { new: true },
                },
                {
                    name: 'companyAsCreditor',
                    isDisabled: false,
                    order: 21,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
            ],
            parameters: { duns: true },
        },
        proverovaciLight: {
            name: 'proverovaciLight',
            isDisabled: false,
            isAllowed: true,
            order: 107,
            blocks: [
                {
                    name: 'bisnodeCertificates',
                    isDisabled: false,
                    order: 1,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'indicators',
                    isDisabled: false,
                    order: 2,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                    parameters: { debt: true, trade: true },
                },
                {
                    name: 'syntheticIndicators',
                    isDisabled: false,
                    order: 3,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'basicInformation',
                    isDisabled: false,
                    order: 4,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                { name: 'regInfo', isDisabled: false, order: 5, defaultLevel: 10, availableLevels: [10], flags: null },
                { name: 'contacts', isDisabled: false, order: 6, defaultLevel: 10, availableLevels: [10], flags: null },
                {
                    name: 'addresses',
                    isDisabled: false,
                    order: 7,
                    defaultLevel: 20,
                    availableLevels: [20],
                    flags: null,
                },
                { name: 'velikost', isDisabled: false, order: 8, defaultLevel: 20, availableLevels: [20], flags: null },
                {
                    name: 'activities',
                    order: 9,
                    isDisabled: false,
                    defaultLevel: 20,
                    availableLevels: [20],
                    flags: null,
                },
                { name: 'persons', isDisabled: false, order: 10, defaultLevel: 10, availableLevels: [10], flags: null },
                {
                    name: 'ownership',
                    isDisabled: false,
                    order: 15,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'negativeEvents',
                    isDisabled: false,
                    order: 18,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
                {
                    name: 'liens',
                    isDisabled: false,
                    order: 19,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: { new: true },
                },
                {
                    name: 'companyAsCreditor',
                    isDisabled: false,
                    order: 21,
                    defaultLevel: 10,
                    availableLevels: [10],
                    flags: null,
                },
            ],
            parameters: { duns: true },
        },
    },
}

export const accessRightsPortfolio = {
    defaultType: 'admin',
    types: {
        admin: {
            isAllowed: true,
            isDisabled: false,
            name: 'admin',
            order: 1,
            blocks: [
                { name: 'block1', order: 1, isDisabled: false, defaultLevel: 50, availableLevels: [10, 30, 50] },
                { name: 'block2', order: 2, isDisabled: false, defaultLevel: 30, availableLevels: [10, 30] },
                { name: 'block3', order: 3, isDisabled: false, defaultLevel: 50, availableLevels: [10, 30, 50] },
                { name: 'block4', order: 4, isDisabled: false, defaultLevel: 10, availableLevels: [10] },
                { name: 'block5', order: 5, isDisabled: true, defaultLevel: 0, availableLevels: [] },
            ],
            export: ['xls'],
            banner: [],
        },
        kompletni: {
            isAllowed: true,
            isDisabled: false,
            name: 'kompletni',
            order: 2,
            blocks: [
                { name: 'block1', order: 1, isDisabled: false, defaultLevel: 50, availableLevels: [10, 30, 50] },
                { name: 'block2', order: 2, isDisabled: false, defaultLevel: 30, availableLevels: [10, 30] },
                { name: 'block3', order: 3, isDisabled: false, defaultLevel: 50, availableLevels: [10, 30, 50] },
                { name: 'block4', order: 4, isDisabled: false, defaultLevel: 10, availableLevels: [10] },
            ],
            export: ['xls'],
            banner: [],
        },
        podrobny: {
            isAllowed: true,
            isDisabled: false,
            name: 'podrobny',
            order: 3,
            blocks: [
                { name: 'block1', order: 1, isDisabled: false, defaultLevel: 30, availableLevels: [10, 30] },
                { name: 'block3', order: 2, isDisabled: false, defaultLevel: 30, availableLevels: [10, 30] },
                { name: 'block4', order: 3, isDisabled: false, defaultLevel: 10, availableLevels: [10] },
            ],
            export: ['xls'],
            banner: ['upsellInline', 'upsellCarousel'],
        },
        zakladni: {
            isAllowed: true,
            isDisabled: false,
            name: 'zakladni',
            order: 4,
            blocks: [
                { name: 'block1', order: 1, isDisabled: false, defaultLevel: 10, availableLevels: [10] },
                { name: 'block4', order: 2, isDisabled: false, defaultLevel: 10, availableLevels: [10] },
            ],
            export: [],
            banner: ['upsellInline', 'upsellCarousel'],
        },
    },
}
